export default {
  mounted () {
    const that = this

    this.$nextTick(() => {
      that.controller = new ScrollMagic.Controller({})

      for (let i = 0; i < document.querySelectorAll('[data-anim]').length; i++) {
        const scene = new ScrollMagic.Scene({ triggerElement: document.querySelectorAll('[data-anim]')[i], triggerHook: 1, duration: 750 })
          .addTo(that.controller)

        scene.on('enter', function (event) {
          event.currentTarget.triggerElement().classList.add('isEntered')
        })
      }
    })
  },

  beforeDestroy () {
    this.controller = this.controller.destroy()
  }
}
